var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.countdownTemplate,{tag:"component",staticClass:"bg-color-ea-vgas-countdown-bg px-2 py-2 lh-1 rounded-sm",attrs:{"giveaway":_vm.giveaway,"label":_vm.label,"label-color":"ea-vgas-countdown-label","countdown-color":"ea-vgas-countdown"}})}
var staticRenderFns = []

export { render, staticRenderFns }